import { faArrowUpRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TitleProps = {
    title: string;
    link?: string;
};

function TitleBox({ children, isLink = false }: { children: React.ReactNode; isLink?: boolean }) {
    return (
        <div className="w-fit group">
            <div className="flex items-start space-x-3 pr-2">{children}</div>
            <div
                className={`w-full h-1 ${isLink ? "bg-primary group-hover:bg-on-bg-image" : "bg-on-bg-image"}`}
            />
        </div>
    );
}

const baseStyle = "text-4xl text-on-bg-image font-bold uppercase";
export default function Title({ title, link }: TitleProps) {
    return (
        <>
            {link ? (
                <a href={link} target="_blank" rel="noopener noreferrer">
                    <TitleBox isLink>
                        <span className={baseStyle}>{title}</span>
                        <FontAwesomeIcon
                            icon={faArrowUpRight}
                            className="text-2xl mt-1 text-on-bg-image"
                        />
                    </TitleBox>
                </a>
            ) : (
                <TitleBox>
                    <span className={baseStyle}>{title}</span>
                </TitleBox>
            )}
        </>
    );
}
